var chunkMapping = {
	"13": [
		8394
	],
	"335": [
		335
	],
	"394": [
		1394
	]
};
var idToExternalAndNameMapping = {
	"335": [
		"default",
		"./caveatRoutes",
		7419
	],
	"1394": [
		"default",
		"./initiatingDocsRoutes",
		5573
	],
	"8394": [
		"default",
		"./simpleProcedureRoutes",
		9411
	]
};
var idToRemoteMap = {
	"335": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 7419
		}
	],
	"1394": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 5573
		}
	],
	"8394": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 9411
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}